import { App, camelize, ComponentPublicInstance, createApp } from 'vue';
import EventEmitter from 'events';
import { AppComponent } from './types';

/**
 * @deprecated Will be removed in the future because cmp.cls signature will change. Use initializeComponents when possible
 */
export default function init(components: AppComponent[], eventBus: EventEmitter) {
  components.map((cmp) => {
    if (typeof cmp.onlyIf === 'function' && !cmp.onlyIf()) {
      return;
    }

    const els = Array.from(document.querySelectorAll(cmp.selector));

    [...els].map(el => {
      if (typeof cmp.onlyIfEl === 'function' && !cmp.onlyIfEl(el)) {
        return;
      }

      new cmp.cls(el, eventBus, {
        selector: cmp.selector,
        ...(cmp.options || {})
      });
    });
  });
}

export function initializeComponents(
  components: AppComponent[],
  eventBus: EventEmitter
) {
  components.map((component) => {
    if (typeof component.onlyIf === 'function' && !component.onlyIf()) {
      return;
    }

    [...Array.from(document.querySelectorAll(component.selector))].map((element) => {
      if (typeof component.onlyIfEl === 'function' && !component.onlyIfEl(element)) {
        return;
      }

      new component.cls(
        element,
        {
          selector: component.selector,
          ...(component.options || {})
        },
        eventBus
      );
    });
  });
}

export function initializeVueComponentOnEl<ComponentInstance>(
  el: HTMLElement,
  component: any,
  data: any,
  preloadComponents: [] = [],
  eventBus?: EventEmitter
): {
  app: App,
  componentInstance: ComponentPublicInstance<ComponentInstance>
} {
  const app: App = createApp(component, data);

  if (eventBus) {
    app.provide('eventBus', eventBus);
  }

  preloadComponents.forEach((preloadComponent) => {
    const { name, cmp } = preloadComponent;
    app.component(name, cmp);
  });

  const componentInstance: ComponentPublicInstance<ComponentInstance> = app.mount(el) as ComponentPublicInstance<ComponentInstance>;

  return {
    app,
    componentInstance
  };
}

export function initializeVueComponent(
  eventBus: EventEmitter,
  selector: string,
  component: any,
  options: object = {},
  preloadComponents: [] = []
) {
  const els = document.querySelectorAll(selector);

  const data = {};
  Object.keys(options).forEach((key) => data[key] = options[key]);

  Array.from(els).forEach((el: HTMLElement) => {
    const componentData = { ...data };

    Array.from(el.attributes).forEach((attr) => {
      if (!attr.name.startsWith('data-')) {
        return;
      }

      const attributeName = attr.name.substring('data-'.length);
      const name = camelize(attributeName);

      try {
        componentData[name] = JSON.parse(attr.value);
      } catch (err) {
        componentData[name] = attr.value;
      }
    });

    initializeVueComponentOnEl(el, component, componentData, preloadComponents, eventBus);
  });
}
